export default "__VITE_ASSET__5c6a4d8b__"